<template>
  <div class="notification">
    <ul class="nav nav-tabs"
        role="tablist">
      <li class="nav-item">
        <a class="nav-link active"
           href="#message"
           role="tab"
           data-toggle="tab" >message</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           href="#tasks"
           role="tab"
           data-toggle="tab">tasks</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           href="#events"
           role="tab"
           data-toggle="tab">events</a>
      </li>

    </ul>
    <div class="tab-content">
      <div id="message"
           role="tabpanel"
           class="tab-pane fade in active"/>
      <div id="tasks"
           role="tabpanel"
           class="tab-pane fade in active"/>
      <div id="events"
           role="tabpanel"
           class="tab-pane fade in active"/>
    </div>
  </div>
</template>
<script>
export default {
	name: 'tabs-notification'

}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/web/rightMenu/tabs-notification.vue